import {
  Button,
  Group,
  Paper,
  Radio,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import React, { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import CreatableContactListSelector from "../../../../../components/Selectors/CreatableContactListSelector";
import BackButton from "../../../../../components/View/BackButton";
import { IconArrowRight, IconDeviceFloppy } from "@tabler/icons-react";

const NurturingContacts = ({
  list,
  setList,
  setActiveStep,
  isPast,
  handleFinish,
}) => {
  const lang = useLanguage((s) => s.language);
  const [listState, setListState] = useState(list?.id ? 2 : 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setActiveStep("workflow");
  };

  const finishNoProg = () => {
    setTimeout(() => {
      handleFinish(true);
    }, 100);
  };

  return (
    <Paper component={Stack} withBorder p={"lg"} gap={"sm"}>
      <Title order={4}>{lang.prm.nurturing.step2.title}</Title>
      <Text>{lang.prm.nurturing.step2.text}</Text>

      <Stack w="100%" mt={16} component={"form"} onSubmit={handleSubmit}>
        <Group wrap="nowrap" align="end" gap={64}>
          <Radio
            label={lang.targeting_linkedin_google.create_new_list}
            name="list_state"
            checked={listState === 1}
            size="md"
            onChange={() => {
              setListState(1);
              setList(null);
            }}
            disabled={isPast}
          />
          <Radio
            label={lang.targeting_linkedin_google.import}
            name="list_state"
            size="md"
            checked={listState === 2}
            onChange={() => {
              setListState(2);
              setList(null);
            }}
            disabled={isPast}
          />
        </Group>
        {listState === 1 ? (
          <TextInput
            id="new-list-name"
            name="contact_list_name"
            defaultValue={list?.id ? undefined : list?.name}
            w={"100%"}
            size="md"
            disabled={listState !== 1 || isPast}
            styles={{ label: { fontSize: 13 } }}
            label={lang.targeting_linkedin_google.list_name}
            placeholder={lang.targeting_linkedin_google.list_name}
            onChange={(e) => setList({ id: null, name: e.target.value })}
            required={listState === 1}
          />
        ) : (
          <CreatableContactListSelector
            value={list}
            setValue={setList}
            label={lang.targeting_linkedin_google.select_list}
            placeholder={lang.contact_lists.create.dialog.desc}
            w={"100%"}
            size="md"
            disabled={listState !== 2 || isPast}
            styles={{ label: { fontSize: 13 } }}
            required={listState === 2}
            disableCreate
            noDesc
          />
        )}

        <Group mt={"md"} gap={"lg"}>
          <BackButton
            label={lang.global.back}
            onClick={() => setActiveStep("filters")}
            size="md"
          />

          <Button type="submit" size="md" rightSection={<IconArrowRight />}>
            {lang.global.next}
          </Button>

          <Button
            ml={"auto"}
            onClick={() => setActiveStep("review")}
            size="md"
            rightSection={<IconDeviceFloppy />}
          >
            {lang.global.finish}
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
};

export default NurturingContacts;
